
export type SimpleTest200 = {
  response?: string;
  success?: boolean;
};
